<template>
  <div class="home">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col>
          <v-card>
            <v-card-title class="text-h4">
              Niantic Pass
              <v-chip class="ml-4" color="info" outlined label small
                >v23.04</v-chip
              >
            </v-card-title>
            <v-card-subtitle>前台机构通行验证生成程序</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col>
          <v-alert
            border="left"
            colored-border
            type="warning"
            elevation="2"
            v-if="!isPWA"
          >
            您尚未使用 PWA，请立即考虑安装 PWA 以避免浏览器状态栏暴露的风险！
          </v-alert>
          <v-alert
            border="left"
            colored-border
            type="error"
            elevation="2"
            v-if="!$store.getters.canGenCode"
          >
            学校从 4.3 开始启用刷码登录，需要有效账户用以生成入校二维码。
          </v-alert>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate>
                登录信息（用于入校二维码生成）
                <template v-slot:actions>
                  <v-icon :color="isIDFilled ? 'success' : 'warning'">{{
                    isIDFilled ? "mdi-check" : "mdi-information"
                  }}</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-alert dense border="left" type="info"
                  >密码仅存储于浏览器，非常安全。</v-alert
                >
                <v-alert dense border="left" type="warning"
                  >需要任何有效账户，需要向学校相关服务发起请求。</v-alert
                >
                <v-expand-transition>
                  <v-card-text>
                    <v-form ref="form">
                      <v-text-field
                        v-model="uID"
                        label="学号/工号/ID"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="uPass"
                        type="password"
                        label="密码"
                        required
                      ></v-text-field>
                      <v-switch
                        v-model="uMode"
                        :label="
                          '登录模式: ' + (uMode ? '统一身份认证' : '本地账户')
                        "
                      ></v-switch>
                    </v-form>
                  </v-card-text>
                </v-expand-transition>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate>
                您的信息（可选，用于旧版界面）
                <template v-slot:actions>
                  <v-icon :color="isFilled ? 'success' : 'warning'">{{
                    isFilled ? "mdi-check" : "mdi-information"
                  }}</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expand-transition>
                  <v-card-text>
                    <v-alert dense border="left" type="info"
                      >此信息仅存储于浏览器，非常安全。</v-alert
                    >
                    <v-form ref="form">
                      <v-text-field
                        v-model="uName"
                        label="姓名"
                        required
                      ></v-text-field>
                      <v-select
                        v-model="uType"
                        :items="regType"
                        label="用户类型"
                        required
                      ></v-select>
                      <v-select
                        v-model="uAuth"
                        :items="authType"
                        label="授权类型"
                        required
                      ></v-select>
                    </v-form>
                  </v-card-text>
                </v-expand-transition>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col>
          <v-row no-gutters>
            <v-col cols="12" class="my-1">
              <v-btn
                block
                color="primary"
                x-large
                :disabled="!isFilled || !$store.getters.canGenCode"
                to="/code"
              >
                <v-icon left>mdi-qrcode</v-icon>二维码
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-divider class="my-1" />
            </v-col>
            <v-col cols="6" class="pr-1 my-1">
              <v-btn
                block
                color="primary"
                x-large
                :disabled="!isFilled"
                to="/info/in"
              >
                <v-icon left>mdi-certificate</v-icon>入校授权（旧）
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-1 my-1">
              <v-btn
                block
                color="primary"
                x-large
                :disabled="!isFilled"
                to="/info/out"
              >
                <v-icon left>mdi-certificate</v-icon>出校授权（旧）
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-footer color="gray" absolute class="justify-center"
        >Niantic Project CN &copy; {{ new Date().getFullYear() }}</v-footer
      >
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Home",
  data: () => ({
    showInfoInput: true,
    showIDInput: false,
    regType: [
      "本科生",
      "研究生（硕士）",
      "研究生（博士）",
      "在编教工",
      "奈安提克计划成员",
    ],
    authType: ["本科", "研究生", "继教生", "教工"],
  }),
  created() {
    if (this.isFilled) this.showInfoInput = false;
  },
  computed: {
    isPWA: {
      get() {
        return (
          window.matchMedia("(display-mode: standalone)").matches ||
          window.navigator.standalone ||
          document.referrer.includes("android-app://")
        );
      },
    },
    panel: {
      get() {
        var ret = [];
        if (this.showInfoInput) ret.push(0);
        if (this.showIDInput) ret.push(1);
        return ret;
      },
      set(arr) {
        if (arr.includes(0)) this.showInfoInput = true;
        else this.showInfoInput = false;
        if (arr.includes(1)) this.showIDInput = true;
        else this.showIDInput = false;
      },
    },
    isFilled: {
      get() {
        return this.$store.getters.isFilled;
      },
    },
    isIDFilled: {
      get() {
        return this.$store.getters.isIDFilled;
      },
    },
    uName: {
      get() {
        return this.$store.state.uName;
      },
      set(value) {
        this.$store.commit("uNameUpdate", value);
      },
    },
    uMode: {
      get() {
        return this.$store.state.uMode;
      },
      set(value) {
        this.$store.commit("uModeUpdate", value);
      },
    },
    uType: {
      get() {
        return this.$store.state.uType;
      },
      set(value) {
        this.$store.commit("uTypeUpdate", value);
      },
    },
    uAuth: {
      get() {
        return this.$store.state.uAuth;
      },
      set(value) {
        this.$store.commit("uAuthUpdate", value);
      },
    },
    uID: {
      get() {
        return this.$store.state.uID;
      },
      set(value) {
        this.$store.commit("uIDUpdate", value);
      },
    },
    uPass: {
      get() {
        return this.$store.state.uPass;
      },
      set(value) {
        this.$store.commit("uPassUpdate", value);
      },
    },
  },
};
</script>
